import { Model } from 'vue-models'

export default class Project extends Model {
  static defaults () {
    return {
      name: 'project',
      basePath: 'projects',
      computed: {
        __str__ () { return this.name }
      }
    }
  }
  static schema () {
    return {
      id: { type: Number },
      name: { type: String },
      subscribers: { type: Array,
        items: {
          type: Object,
          properties: {
            id: { type: Number },
            username: { type: String },
            first_name: { type: String },
            last_name: { type: String },
            email: { type: String }
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/project.js